import { computed, ComputedRef, ref, unref } from 'vue'
import { Timer, Timers } from '../types/timers'
import { find, findLast } from 'lodash-es'
import { useAllTimers } from '../store/useAllTimers'
import { storeToRefs } from 'pinia'

/**
 * @Type UseGetOdometerReadingReturn
 */
type UseGetOdometerReadingReturn = {
  /**returns the last available odometer_end. If none available, 0 will be returned */
  previous: ComputedRef<number>
  /**returns the next available odometer_start. If none available, it will return previous()*/
  next: ComputedRef<number>
}

/**
 *
 * @param options
 * {index: number Index defaults to the last element on the most recent day.
 * timersOnDevice: Timers[] Array of all rows of timers on device, most recent day is first in index. For testing.
 * @returns UseGetOdometerReadingReturn
 */
export const useGetOdometerReading = (
  options: { index?: number; timersOnDevice?: Timers[] } = {}
): UseGetOdometerReadingReturn => {
  //default timers on device to store
  const { getAllTimersOnDevice } = storeToRefs(useAllTimers())
  const timersOnDevice = ref()
  if (typeof options.timersOnDevice === 'undefined') {
    timersOnDevice.value = unref(getAllTimersOnDevice)
  } else {
    timersOnDevice.value = options.timersOnDevice
  }
  //Reorder most recent day to last, then flatten the timers
  const timersOnDeviceFlat = computed(() => {
    return timersOnDevice.value.slice(0).reverse().flat(1)
  })

  const startingIndex = computed(() => {
    if (typeof options.index === 'undefined') {
      return timersOnDeviceFlat.value.length - 1
    } else {
      return timersOnDeviceFlat.value.length - (timersOnDevice.value[0].length - options.index)
    }
  })

  const previous = computed(() => {
    const data = findLast(
      timersOnDeviceFlat.value,
      (timer: Timer) => {
        if (timer.data.odometer_end && timer.data.odometer_end > 0) return true
        else false
      },
      startingIndex.value
    ) as Timer | undefined

    if (typeof data !== 'undefined') return data.data.odometer_end as number
    else return 0
  })

  const next = computed(() => {
    const data = find(
      timersOnDeviceFlat.value,
      (timer: Timer) => {
        if (timer.data.odometer_end && timer.data.odometer_end > 0) return true
        else false
      },
      startingIndex.value
    ) as Timer | undefined

    if (typeof data !== 'undefined') return data.data.odometer_start as number
    else return previous.value
  })

  return {
    previous,
    next,
  }
}
